import React from 'react';
import { UsersIcon } from 'lucide-react';
interface ScarcityBarProps {
  tone?: 'dark' | 'light';
  spotsLeft?: number;
  total?: number;
}
export function ScarcityBar({
  tone = 'dark',
  spotsLeft = 12,
  total = 200
}: ScarcityBarProps) {
  const claimed = total - spotsLeft;
  const percent = Math.round(claimed / total * 100);
  const isDark = tone === 'dark';
  return <div className={['w-full max-w-xl rounded-2xl px-4 py-4 sm:px-5', isDark ? 'bg-cream-100 ring-1 ring-navy-900/10' : 'bg-white/10 ring-1 ring-white/15'].join(' ')} data-id="element-275" data-mp="2b703u4gie7s3">
      <div className="flex items-center justify-between gap-3" data-id="element-276" data-mp="2273ncq49wf84">
        <p className={['flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.1em] sm:text-xs', isDark ? 'text-navy-900' : 'text-cream-50'].join(' ')} data-id="element-277" data-mp="27557zfhckmlp">
          <UsersIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-278" data-mp="5e1t2e0fclvc" />
          Only {spotsLeft} spots left at $27
        </p>
        <span className={`text-[11px] font-bold tabular-nums sm:text-xs ${isDark ? 'text-clay' : 'text-gold-300'}`} data-id="element-279" data-mp="33lbqot90v03y">
          {percent}%
        </span>
      </div>
      <div className={`mt-2.5 h-2.5 w-full overflow-hidden rounded-full ${isDark ? 'bg-cream-200' : 'bg-white/20'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-280" data-mp="3dbmw6k8cthcy">
        <div className="h-full rounded-full bg-clay" style={{
        width: `${percent}%`
      }} data-id="element-281" data-mp="2gngw8amdnd50" />
      </div>
      <p className={`mt-2 text-[10px] font-medium uppercase tracking-[0.08em] sm:text-[11px] ${isDark ? 'text-navy-700/70' : 'text-cream-100/70'}`} data-id="element-282" data-mp="2unrl5844mhnj">
        {claimed} of {total} promotional spots already claimed
      </p>
    </div>;
}